(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-dsl-f2-dsl-function'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'fixers-f2-f2-dsl-f2-dsl-function'.");
    }
    root['fixers-f2-f2-dsl-f2-dsl-function'] = factory(typeof this['fixers-f2-f2-dsl-f2-dsl-function'] === 'undefined' ? {} : this['fixers-f2-f2-dsl-f2-dsl-function'], this['kotlin-kotlin-stdlib']);
  }
}(this, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  //endregion
  //region block: pre-declaration
  setMetadataFor(F2Function, 'F2Function', interfaceMeta);
  setMetadataFor(F2Supplier, 'F2Supplier', interfaceMeta);
  setMetadataFor(F2Consumer, 'F2Consumer', interfaceMeta);
  //endregion
  function F2Function() {
  }
  function F2Supplier() {
  }
  function F2Consumer() {
  }
  //region block: exports
  function $jsExportAll$(_) {
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$fnc = $f2$dsl.fnc || ($f2$dsl.fnc = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = F2Consumer;
  _.$_$.b = F2Function;
  _.$_$.c = F2Supplier;
  //endregion
  return _;
}));

//# sourceMappingURL=fixers-f2-f2-dsl-f2-dsl-function.js.map
